import { __rest } from 'tslib';
import React, { useRef } from 'react';
import { PeekBox, PeekTooltip, PeekContainedIconButton, PeekTypography } from '@piiqtechnologies/ui-components';
import '../../../../types/AccessDevice.js';
import '../../../../types/Analytics.js';
import '../../../../types/CASACommunity.js';
import '../../../../types/Community.js';
import '../../../../types/DxSettings.js';
import '../../../../types/MagicButton.js';
import '../../../../types/Pannellum.js';
import '../../../../types/Prospect.js';
import '../../../../types/ProspectIntelligence.js';
import { NodeLinkType } from '../../../../types/Space.js';
import '../../../../types/Tour.js';
import { HotspotIcon } from './HotspotIcon.js';

const SceneHotspot = (_a) => {
    var { helpers } = _a, hotspot = __rest(_a, ["helpers"]);
    const hotspotRef = useRef(null);
    const buttonBackground = (hotspot.type === NodeLinkType.Space && "common.purple") || "secondary.main";
    const buttonSxProps = {
        backgroundColor: buttonBackground,
        zIndex: 1600,
        ":hover": { backgroundColor: buttonBackground },
    };
    const onHotspotClick = () => {
        helpers.clickEventAnalytics((hotspot.type === NodeLinkType.Space && "Linked Space Hotspot") || "Hotspot");
        helpers.loadNodeLink(hotspot);
    };
    return (React.createElement(PeekBox, { position: "relative", ref: hotspotRef },
        React.createElement(PeekTooltip, { PopperProps: {
                disablePortal: true,
                container: hotspotRef === null || hotspotRef === void 0 ? void 0 : hotspotRef.current,
            }, placement: "right", title: hotspot.label, sx: {
                m: 0,
                "& .MuiTooltip-tooltip": {
                    boxShadow: "none",
                    py: 0.5,
                    pr: 1,
                    pl: 3,
                    opacity: 1,
                    whiteSpace: "nowrap",
                    ml: "-20px !important",
                    borderRadius: 3,
                    backgroundColor: "grey.700",
                    color: "text.secondary",
                },
            } },
            React.createElement(PeekContainedIconButton, { onClick: onHotspotClick, sx: buttonSxProps, "aria-label": "scene hotspot" },
                React.createElement(PeekTypography, { color: "text.secondary", fontSize: 22 },
                    React.createElement(HotspotIcon, { type: hotspot.type }))))));
};

export { SceneHotspot, SceneHotspot as default };
